export const createRecordsCache = (recordsLimit: number) => {
  const cache: Map<string, string> = new Map();
  return {
    add: (entryName: string, entryValue: string) => {
      if (cache.size >= recordsLimit && !cache.has(entryName)) {
        cache.clear();
      }
      cache.set(entryName, entryValue);
      return entryValue;
    },
    clear: () => cache.clear(),
    retrieve: (entryName: string) => cache.get(entryName),
  } as const;
};
